import { el } from "date-fns/locale";
import CLO from "../assets/clo.svg";
import CLOSET from "../assets/closet.svg";
import MD from "../assets/md.svg";
import CONNECT from "../assets/closet_connect.svg";
import { Brand } from "../context/AppProvider";
import { useAppContext } from "../hooks/useAppContext";

const ChatProfile = () => {
  const { brand } = useAppContext();

  let src = "";
  let alt = "";
  if (brand === Brand.MD) {
    src = MD;
    alt = "MD";
  } else if (brand === Brand.CLOSET) {
    src = CLOSET;
    alt = "CLOSET";
  } else if (brand === Brand.CLOSET_CONNECT) {
    src = CONNECT;
    alt = "CONNECT";
  } else {
    src = CLO;
    alt = "CLO";
  }

  return (
    <div className="flex w-full items-center justify-start gap-[6px]">
      <img className="h-[30px] w-[30px]" src={src} alt={alt} />
      <span className="text-base font-semibold leading-7 text-grayscale-solid-g10 lg:text-lg">
        {brand === Brand.MD
          ? "Marvelous Designer"
          : brand === "CLOSET"
            ? "CLO-SET"
            : brand === "ALLINONE"
              ? "All In One"
              : brand === "CLOSET_CONNECT"
                ? "CONNECT"
                : "CLO3D"}{" "}
        Chatbot
      </span>
    </div>
  );
};

export default ChatProfile;
